export const baseUrl: string = "https://infodatenbank.seam-release.at/api";
// export const baseUrl: string = "http://localhost:18053/api";
export const apiToken: string = "u1hXH0MkFyCED86mfIyKee4LwGnpX3f24rpz8R91WFs4syjeZ2abt0mzpoHn";
